module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_25.2146de18.jpg";